var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPopupDangerNewVersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2893_9150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4884 0H8.51225C3.81824 0 0 3.81824 0 8.51225V53.9123C0 58.6057 3.81824 62.4239 8.51225 62.4239H28.1538L34.6583 75.4337C35.7915 77.6999 37.5556 79 39.5 79C41.4444 79 43.2085 77.6999 44.3417 75.4337L50.8468 62.4245H70.4884C75.1818 62.4245 79 58.6063 79 53.9123V8.51225C79 3.81824 75.1818 0 70.4884 0V0Z",
    fill: "url(#paint0_linear_2893_9150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 40.4414C35.4901 40.4414 32.2275 43.7039 32.2275 47.7139C32.2275 51.7238 35.4901 54.9863 39.5 54.9863C43.5099 54.9863 46.773 51.7238 46.773 47.7139C46.773 43.7039 43.5099 40.4414 39.5 40.4414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 9.91602C35.4901 9.91602 32.2275 13.1779 32.2275 17.1885V27.882C32.2275 31.8919 35.4901 35.1544 39.5 35.1544C43.5099 35.1544 46.773 31.8919 46.773 27.882V17.1879C46.773 13.1779 43.5099 9.91602 39.5 9.91602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2893_9150",
    x1: 39.5,
    y1: 0,
    x2: 39.5,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB0B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2893_9150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 79,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupDangerNewVersion);
export default __webpack_public_path__ + "static/media/icon_popup_danger_new_version.43e98be60398e434df032c7f3b38b4c1.svg";
export { ForwardRef as ReactComponent };